import {
  GetMasterProvincePostalCode,
  GetMasterCityPostalCode,
} from "../services/MasterCallsService";
import { checkIsNullUndefined } from "./Utils";
import { EnumCountries } from "../commons/EnumCountries";
import { isResultOk, showAlert } from "./FormManager.js";

//Funcionamiento conjunto al introducir algún valor
export const ManageAddressRelation = (usableModel, trigger, setAll, value, finishOperation, doTraduction) => {
  let auxCountryCodes = ["PAI", "EPI"];
  let auxPostalCodes = ["CPO", "ECP"];
  let auxCountry = {};
  let auxPoCo = {};
  if (auxCountryCodes.includes(trigger)) {
    auxCountry.value = value;
  } else {
    auxCountry.value = usableModel.find((attr) => auxCountryCodes.includes(attr.codeAttribute)).value;
  };
  if (auxPostalCodes.includes(trigger)) {
    auxPoCo.value = value;
  } else {
    auxPoCo.value = usableModel.find((attr) => auxPostalCodes.includes(attr.codeAttribute)).value;
  };
  let auxProv = {};
  let auxCity = {};
  if (checkIsControlledCountry(value, trigger, auxCountry, auxCountryCodes)) {
    let auxiliarFunctionValues = {
      first: false,
      setAll: setAll,
      select: null,
      isEdit: null,
      finishOperation: finishOperation,
      doTraduction: doTraduction
    };
    if (auxCountryCodes.includes(trigger)) {
      countryPath(value, auxCountry, auxProv, auxCity, auxPoCo, usableModel, auxiliarFunctionValues);
    } else if (auxPostalCodes.includes(trigger)) {
      checkPostalCodePath(
        auxCountry,
        auxProv,
        auxCity,
        auxPoCo,
        usableModel,
        null,
        auxiliarFunctionValues,
      );
    };
  } else {
    auxProv.value = "";
    auxProv.dropdownValues = [];
    auxCity.value = "";
    auxCity.dropdownValues = [];
    auxPoCo.value = "";
    auxPoCo.dropdownValues = [];
    let auxiliarModel = setAllAddressData(
      auxCountry,
      auxProv,
      auxCity,
      auxPoCo,
      usableModel
    );
    setAll(auxiliarModel);
  };
};

const checkIsControlledCountry = (value, trigger, auxCountry, auxCountryCodes) => {
  return (!checkIsNullUndefined(value) &&
    ((!auxCountryCodes.includes(trigger) &&
      (auxCountry.value == EnumCountries.ESP || auxCountry.value == EnumCountries.AND)) ||
      ((auxCountryCodes.includes(trigger)) &&
        (value == EnumCountries.ESP || value == EnumCountries.AND))));
};

const countryPath = (value, auxCountry, auxProv, auxCity, auxPoCo, usableModel, auxiliarFunctionValues) => {
  auxCountry.value = value;
  auxProv.value = "";
  auxProv.dropdownValues = [];
  auxProv.originalValues = [];
  auxCity.value = "";
  auxCity.dropdownValues = [];
  auxCity.originalValues = [];
  auxPoCo.value = "";
  auxPoCo.dropdownValues = [];
  auxPoCo.originalValues = [];
  let auxiliarModel = setAllAddressData(
    auxCountry,
    auxProv,
    auxCity,
    auxPoCo,
    usableModel
  );
  auxiliarFunctionValues.setAll(auxiliarModel);
};

//Para cargar por primera vez los valores que vienen prerrellenados o vacios
export const ManageAddressFirstIteration = (
  usableModel,
  setAll,
  auxIsEdit,
  auxEditDirList,
  setIsControlledCountry,
  finishOperation,
  t
) => {
  let auxCountryCodes = ["PAI", "EPI"];
  let auxPostalCodes = ["CPO", "ECP"];
  let auxProvCodes = ["PRO", "EPR"];
  let auxCityCodes = ["POB", "EPO"];
  let auxCountry = {};
  let auxProv = {};
  let auxCity = {};
  let auxPoCo = {};
  usableModel.forEach((attribute) => {
    if (auxCountryCodes.includes(attribute.codeAttribute)) {
      auxCountry.value = attribute.value;
    };
    if (auxPostalCodes.includes(attribute.codeAttribute)) {
      auxPoCo.value = attribute.value;
    };
    if (auxProvCodes.includes(attribute.codeAttribute)) {
      auxProv.value = attribute.value;
    };
    if (auxCityCodes.includes(attribute.codeAttribute)) {
      auxCity.value = attribute.value;
    };
  });
  auxProv.dropdownValues = [];
  auxCity.dropdownValues = [];
  if (auxCountry.value == EnumCountries.ESP || auxCountry.value == EnumCountries.AND) {
    if (!checkIsNullUndefined(setIsControlledCountry)) {
      setIsControlledCountry(true);
    };
    let auxFunctionValues = { setAll: setAll, auxIsEdit: auxIsEdit, finishOperation: finishOperation, t: t }
    firstIterationControlledCountryPath(auxCountry, auxProv, auxCity, auxPoCo, usableModel, auxEditDirList, auxFunctionValues);
  } else {
    if (!checkIsNullUndefined(setIsControlledCountry)) {
      setIsControlledCountry(false);
    };
    let auxiliarModel = setAllAddressData(
      auxCountry,
      auxProv,
      auxCity,
      auxPoCo,
      usableModel
    );
    setAll(auxiliarModel, true, auxIsEdit, auxEditDirList);
  };
};

const firstIterationControlledCountryPath = (auxCountry, auxProv, auxCity, auxPoCo, usableModel, auxEditDirList, auxFunctionValues) => {
  if (!checkIsNullUndefined(auxPoCo.value)) {
    let auxiliarFunctionValues = {
      first: true,
      setAll: auxFunctionValues.setAll,
      select: true,
      isEdit: auxFunctionValues.auxIsEdit,
      finishOperation: auxFunctionValues.finishOperation,
    };
    checkPostalCodePath(
      auxCountry,
      auxProv,
      auxCity,
      auxPoCo,
      usableModel,
      auxEditDirList,
      auxiliarFunctionValues
    );
  };
};

const checkPostalCodePath = (auxCountry, auxProv, auxCity, auxPoCo, usableModel, auxEditDirList, auxFunctionValues) => {
  if (auxPoCo?.value.length == 5) {
    mandatoryPostalCode(auxCountry, auxProv, auxCity, auxPoCo, usableModel, auxEditDirList, auxFunctionValues);
  } else {
    auxProv.dropdownValues = [];
    auxProv.value = "";
    auxCity.dropdownValues = [];
    auxCity.value = "";
    managePostalCodePath(auxCity, auxCountry, auxPoCo, auxProv, usableModel, auxEditDirList, auxFunctionValues);
  };
};

//Cuando el campo introducido es el código psotal
const mandatoryPostalCode = (
  auxCountry,
  auxProv,
  auxCity,
  auxPoCo,
  usableModel,
  auxEditDirList,
  auxiliarFunctionValues
) => {
  let auxPostalCode = auxPoCo.value;
  let getMasterProvincePostalCode = GetMasterProvincePostalCode(auxPostalCode, true);
  let getMasterCityPostalCode = GetMasterCityPostalCode(auxPostalCode, true);
  Promise.all([getMasterProvincePostalCode, getMasterCityPostalCode]).then((results) => {
    let postalCodeProvince = results[0];
    let postalCodeCities = results[1];
    if (isResultOk([postalCodeProvince, postalCodeCities])) {
      auxProv.dropdownValues = postalCodeProvince;
      auxProv.value = postalCodeProvince[0].code;
      // let auxOnlyOneCity = postalCodeCities.length === 1;
      auxCity.dropdownValues = postalCodeCities;
      manageCityValue(auxiliarFunctionValues.first, auxCity)
      // auxCity.value = auxOnlyOneCity ? postalCodeCities[0].codeLocalidad : "";
      let auxFunctionValues = {
        setAll: auxiliarFunctionValues.setAll,
        select: auxiliarFunctionValues.select,
        isEdit: auxiliarFunctionValues.isEdit
      };
      managePostalCodePath(auxCity, auxCountry, auxPoCo, auxProv, usableModel, auxEditDirList, auxFunctionValues);
    } else {
      showAlert([postalCodeProvince, postalCodeCities], auxiliarFunctionValues.finishOperation, auxiliarFunctionValues.doTraduction);
    };
  });
};

const manageCityValue = (firstIteration, auxCity) => {
  let auxOnlyOneCity = auxCity.dropdownValues.length === 1;
  if(firstIteration){
    let auxIsInList = auxCity.dropdownValues.find((city) => city.codeLocalidad === auxCity.value);
    if(checkIsNullUndefined(auxIsInList)){
      auxCity.value = "";
    };
  } else {
    auxCity.value = auxOnlyOneCity ? auxCity.dropdownValues[0].codeLocalidad : "";
  };
};

const managePostalCodePath = (auxCity, auxCountry, auxPoCo, auxProv, usableModel, auxEditDirList, auxFunctionValues) => {
  let auxiliarModel = setAllAddressData(
    auxCountry,
    auxProv,
    auxCity,
    auxPoCo,
    usableModel
  );
  auxFunctionValues.setAll(auxiliarModel, auxFunctionValues.select, auxFunctionValues.isEdit, auxEditDirList);
};

const setAllAddressData = (
  auxCountry,
  auxProv,
  auxCity,
  auxPoCo,
  auxUsableMod
) => {
  let auxiliarModel = JSON.parse(JSON.stringify(auxUsableMod));
  auxiliarModel.forEach((element) => {
    if (element.codeAttribute === "PAI" || element.codeAttribute === "EPI") {
      element.value = auxCountry.value;
    }
    if (element.codeAttribute === "PRO" || element.codeAttribute === "EPR") {
      element.value = checkIsNullUndefined(auxProv.value) ? "" : auxProv.value;
      element.dropdownValues = auxProv.dropdownValues;
    }
    if (element.codeAttribute === "POB" || element.codeAttribute === "EPO") {
      element.value = checkIsNullUndefined(auxCity.value) ? "" : auxCity.value;
      element.dropdownValues = auxCity.dropdownValues;
    }
    if (element.codeAttribute === "CPO" || element.codeAttribute === "ECP") {
      element.value = checkIsNullUndefined(auxPoCo.value) ? "" : auxPoCo.value;
    };
  });
  return auxiliarModel;
};
